<albert-content-sidebar-list-view
  [itemSize]="itemSize"
  [service]="contentUnitState"
  [(sidebarDrawerVisible)]="sidebarDrawerVisible"
>
  <ng-template #itemTemplate
               let-item
  >
    <div class="sidebar-list-row box-border overflow-hidden border-b border-gray-300"
         [attr.data-test]="'cu-item-' + item.uuid"
    >
      <albert-list-view-cu-list-item
        [item]="item"
        (itemClicked)="sidebarDrawerVisible.set(false)"
      />
    </div>
  </ng-template>
</albert-content-sidebar-list-view>
